import { useEffect } from "react";

export const OktaDialogStartPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const target = params.get("target");
    if (!target) {
      document.body.innerText = "Missing Okta target URL.";
      return;
    }
    // Office dialog must open same-origin first, then can redirect to IdP.
    window.location.replace(target);
  }, []);

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center">
      <p className="text-sm text-muted-foreground">Opening sign-in...</p>
    </div>
  );
};
